export default __webpack_public_path__ + "static/media/textlayer_font.1182b0f8.jpg";